const Team = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-user"></i>
        <p>Team page</p>
      </div>
    </div>
  );
};

export default Team;
